export const PROJECT_READ_PERM = 'projects:read'
export const PROJECT_WRITE_PERM = 'projects:write'
export const PROJECT_TEAM_PERM = 'projects:member:manage'
export const PROJECT_WORK_PERM = 'tasks.write'
export const PROJECT_ASSIGN_PERM = 'tasks.assign'
export const PROJECT_PRICING_PERM = 'catalog:price:write'
export const PROJECT_PRICE_READ_PERM = 'catalog:price:read'
export const CATALOG_READ_PERM = 'catalog:module:read'
export const CATALOG_WRITE_PERM = 'catalog:module:write'
export const PROJECT_RELEASE_PERM = 'releases.write'
export const PROJECT_REPORT_PERM = 'reports.read'
export const PROJECT_INSTALL_PERM = 'accounts.read'
export const PROJECT_SETTINGS_PERM = 'projects:settings'
export const PROJECT_ARCHIVE_PERM = 'projects:archive'
